import HtmlToReactParser from "html-to-react";

const htmlParser = new HtmlToReactParser.Parser();

export { htmlParser };
